import { newApi } from './api.instance';
import { LaunchesSearchRequestDTO } from '../../features/entity/launch/dtos/request.dtos';
import { LaunchesResponseDTO } from '../../features/entity/launch/dtos/response.dtos';

export class LaunchesApis {
  public static async getLaunchesSummary(language?: string) {
    return newApi({ ssrLocale: language })
      .get('v1/launches/summary')
      .then(({ data }) => data);
  }

  public static async getLaunches(
    query: LaunchesSearchRequestDTO,
    locale?: string
  ): Promise<LaunchesResponseDTO> {
    return newApi({ ssrLocale: locale })
      .get(`v1/launches`, {
        params: {
          page: query.pagination.page,
          pageSize: query.pagination.pageSize
        }
      })
      .then(({ data }) => data);
  }

  public static async getTrendingProjects(language?: string) {
    return newApi({ ssrLocale: language })
      .get('v1/launches/trending')
      .then(({ data }) => data);
  }
}
